import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import {
  completarEncuesta,
  fetchEncuesta,
  getUserInfo,
} from '../../../services/deportistaApi';
import { getUserId, sendNotification } from '../../../services/utilsApi.js';
import back from '../../../static/img/back.svg';
import PreguntaCard from '../../../static/assets/encuestas/preguntasCard.js';
import './styles.css';
import Footer from '../footer/footer.js';
import CuadroTexto from '../../../static/assets/cuadroTexto/cuadroTexto';
import LoadingScreen from '../../../static/assets/loadingScreen/loadingScreen';

const Encuesta = () => {
  const navigate = useNavigate();
  const { idEncuesta, fecha } = useParams();
  const [encuesta, setEncuesta] = useState(null);
  const [respuestas, setRespuestas] = useState({});
  const [isComplete, setIsComplete] = useState(false);
  const [uid, setUid] = useState(null);
  const [trainerId, setTrainerId] = useState(null);
  const [userName, setUserName] = useState('');
  const [userSurname, setUserSurname] = useState('');

  const [errorMessage, setErrorMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const {
          data: { user_id },
        } = await getUserId();
        setUid(user_id);

        const {
          data: { perfil },
        } = await getUserInfo(user_id);
        setTrainerId(perfil.entrenador.id);
        setUserName(perfil.nombre);
        setUserSurname(perfil.apellido);
      } catch (err) {
        console.error('Error inicializando usuario:', err);
        setErrorMessage('No fue posible cargar tu perfil.');
      }
    })();
  }, []);

  useEffect(() => {
    if (!uid) return;
    setLoading(true);
    (async () => {
      try {
        const resp = await fetchEncuesta(uid, fecha);
        const ev = resp?.data?.encuestas?.find(
          (e) => e.id_encuesta_deportista === Number(idEncuesta)
        );
        if (!ev) {
          setErrorMessage('No se encontró la encuesta solicitada.');
        } else {
          setEncuesta(ev);
          const init = {};
          ev.preguntas.forEach((p) => {
            init[p.id_pregunta] = null;
          });
          setRespuestas(init);
        }
      } catch (err) {
        console.error('Error cargando encuesta:', err);
        setErrorMessage('Error al cargar la encuesta.');
      } finally {
        setLoading(false);
      }
    })();
  }, [uid, idEncuesta, fecha]);

  useEffect(() => {
    if (!encuesta) return;
    setIsComplete(Object.values(respuestas).every((r) => r !== null));
  }, [respuestas, encuesta]);

  const handleRespuesta = (idPregunta, valor) => {
    setRespuestas((prev) => ({ ...prev, [idPregunta]: valor }));
  };

  const handleCompletado = async () => {
    if (!isComplete) return;
    setLoading(true);
    try {
      await completarEncuesta(uid, idEncuesta, fecha, {
        respuestas: Object.entries(respuestas).map(([id, resp]) => ({
          id_pregunta: Number(id),
          respuesta: resp,
        })),
      });
      setSuccessMessage('Encuesta completada exitosamente.');

      if (trainerId) {
        const asunto = 'Encuesta completada';
        const mensaje = `${userName} ${userSurname} completó la encuesta "${encuesta.nombre_encuesta}".`;
        await sendNotification({
          id_desde: uid,
          id_hasta: trainerId,
          asunto,
          mensaje,
          id_tipo: 1,
          visto: false,
          created_at: `${fecha}T00:00:00Z`,
        });
      }
    } catch (err) {
      console.error('Error completando encuesta o enviando notificación:', err);
      setErrorMessage('Hubo un error al procesar la encuesta.');
    } finally {
      setLoading(false);
    }
  };

  const handleBack = () => navigate(-1);

  if (loading) return <LoadingScreen />;

  return (
    <div className="encuesta-container">
      {errorMessage && (
        <CuadroTexto
          message={errorMessage}
          onAccept={() => setErrorMessage('')}
          showCancel={false}
        />
      )}
      {successMessage && (
        <CuadroTexto
          message={successMessage}
          onAccept={() => {
            setSuccessMessage('');
            navigate(-1);
          }}
          showCancel={false}
        />
      )}
      <div className="encuesta-header">
        <button className="back" onClick={handleBack}>
          <img src={back} alt="Regresar" />
        </button>
        <div className="encuesta-title">Encuesta</div>
      </div>
      <div className="encuesta-subtitulo">{encuesta?.nombre_encuesta}</div>
      <div className="encuesta-preguntas">
        {encuesta?.preguntas.map((pregunta, index) => (
          <PreguntaCard
            key={pregunta.id_pregunta}
            pregunta={pregunta}
            respuestaBD={encuesta.respuestas?.[index]?.respuesta}
            respuesta={respuestas[pregunta.id_pregunta]}
            onChange={(valor) => handleRespuesta(pregunta.id_pregunta, valor)}
          />
        ))}
      </div>
      
      {encuesta?.estado==="pendiente"
          ?<button
            className={`completado-button ${isComplete ? 'activo' : 'inactivo'}`}
            onClick={handleCompletado}
            disabled={!isComplete}
          >
            Completado
          </button>
          :<div></div>
      }
      <Footer activeScreen="entrenamiento" />
    </div>
  );
};

export default Encuesta;
